import { connect } from 'react-redux'
import ContactListView from './ContactListView.jsx'
import { fetchContactLists }
  from 'src/legacy/redux/actions/contactList'
import withUseHooks from 'src/legacy/components/withUseHooks.jsx'

const mapStateToProps = (state, ownProps) => {
  return {
    contactLists: state.legacyRootReducer.contactLists.items,
    loading: state.legacyRootReducer.contactLists.loading,
    currentPage: state.legacyRootReducer.contactLists.pagination.current,
    totalPages: state.legacyRootReducer.contactLists.pagination.totalPages,
    contactList: state.legacyRootReducer.contactLists.contactList,
    user: state.users.me,
    account: state.accounts.item,
  }
}

const mapDispatchToProps = (dispatch) => {
  return {
    fetchContactLists: (page, query) => {
      return dispatch(fetchContactLists(page, query));
    }
  }
}

const ContactListContainer = connect(
  mapStateToProps,
  mapDispatchToProps
)(ContactListView)

export default withUseHooks(ContactListContainer)